<template>
  <label
    class="block font-inter text-xs font-medium leading-6 text-gray-200 transition duration-300 group-focus-within/input:!text-gray-100 group-focus-within:!text-gray-100 group-hover:text-gray-100 dark:group-focus-within/input:!text-gray-100"
    :class="{
      '!text-gray-100': opened || changed,
      '!text-gray-300': disabled,
      'no-margin': noMargin,
      'flex items-center': tip || changed,
    }"
    :for="forId"
  >
    <span><slot /></span>

    <TTip v-if="tip !== ''" :tip="tip" />
    <div
      v-if="changed && !disabled"
      class="flex items-center text-accent-1 cursor-pointer opacity-75 hover:opacity-100"
      v-tooltip="{
        content: tooltip,
      }"
      data-testid="reset-label"
      tabindex="0"
      @click.stop.prevent="$emit('reset')"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5156 8.03906C13.8203 7.75781 13.8203 7.26562 13.5156 6.98438C13.2344 6.67969 12.7422 6.67969 12.4609 6.98438L10 9.44531L7.51562 6.98438C7.23438 6.67969 6.74219 6.67969 6.46094 6.98438C6.15625 7.26562 6.15625 7.75781 6.46094 8.03906L8.92188 10.5L6.46094 12.9844C6.15625 13.2656 6.15625 13.7578 6.46094 14.0391C6.74219 14.3438 7.23438 14.3438 7.51562 14.0391L10 11.5781L12.4609 14.0391C12.7422 14.3438 13.2344 14.3438 13.5156 14.0391C13.8203 13.7578 13.8203 13.2656 13.5156 12.9844L11.0547 10.5L13.5156 8.03906Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </label>
</template>
<script lang="ts" setup>
import TTip from "../TTip/TTip.vue";
import { vTooltip } from "floating-vue";
import { ref } from "vue";

const props = defineProps({
  for: {
    type: String,
    default: "",
  },
  opened: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  noMargin: {
    type: Boolean,
    default: false,
  },
  tip: {
    type: String,
    default: "",
  },
  changed: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: undefined,
  },
});

defineEmits(["reset"]);

const forId = ref(props.for);
</script>
